/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResendCodeAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ResendCodeAction({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/ResendCodeAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let signupConfirmRequestCanRequestNewCodeValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm_request',
path: 'can_request_new_code',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(signupConfirmRequestCanRequestNewCodeValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}